import React from 'react';
import { IndexPageTemplate } from '../../templates/index-page';
import { NetlifyProps } from '../../types';

const IndexPagePreview = ({ entry, getAsset }: NetlifyProps) => {
  const data = entry.getIn(['data']).toJS();

  if (data) {
    return (
      <IndexPageTemplate
        image={data.image}
        byline={data.byline}
        youtube={data.youtube}
        isEditMode
      />
    );
  }
  return <div>Loading...</div>;
};

export default IndexPagePreview;
